module.exports = __webpack_public_path__ + "img/addre.77fc8bb5.png";